import PropTypes from 'prop-types';

/**
 * Placeholder tiles for the first load of the gallery.
 *
 * Deliberately mirrors the real grid's geometry so the layout does not jump when
 * the images arrive. Shown instead of — not alongside — the upload dropzone: on a
 * first paint the library's size is unknown, and offering "Drop images" next to an
 * empty grid reads as "you have no images" before that is known to be true.
 */
const ImageGridSkeleton = ({ count }) => (
  <div
    className="grid grid-cols-[repeat(auto-fill,minmax(180px,1fr))] gap-3"
    aria-busy="true"
    aria-label="Loading images"
  >
    {Array.from({ length: count }, (_, index) => (
      <div key={index} className="aspect-[4/3] animate-pulse rounded-lg bg-gray-10" />
    ))}
  </div>
);

ImageGridSkeleton.propTypes = {
  count: PropTypes.number,
};

ImageGridSkeleton.defaultProps = {
  count: 8,
};

export default ImageGridSkeleton;
